import axios from 'axios';
import { getConfig } from './config';
import { refreshToken } from '../utils/authService';
import { decryptData } from './sec';
import { toast } from 'react-toastify';

var _ = require('lodash');

const config = getConfig();
let isRefreshing = false;
let failedQueue = [];
const ENV = window.reloy_env.ENV || process.env.REACT_APP_ENV;
const replaceCDNValues = (object) => {
    const newObject = _.clone(object);

    _.each(object, (val, key) => {
        if (val && typeof val === 'string' && val.includes('cdn.loyalie.in')) {
            newObject[key] = val.replace('cdn.loyalie.in', 'cdn.loyalie.in');
        } else if (typeof val === 'object' || typeof val === 'array') {
            newObject[key] = replaceCDNValues(val);
        }
    });

    return newObject;
};

const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });

    failedQueue = [];
};

const getBaseUrl = () => {
    switch (ENV) {
        case 'PRODUCTION':
            return 'https://prod.loyalie.in';
        case 'UAT':
            return 'https://uat.loyalie.in';
        case 'LOCAL':
            return 'http://localhost:8080';
        default:
            return 'https://dev.loyalie.in';
    }
};

export const setWinnreAuthToken = (authToken) => {
    winnreAuth.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
};

export const deleteWinnreAuthToken = () => {
    delete winnreAuth.defaults.headers.common['Authorization'];
};

const cmsClient = axios.create({
    baseURL: getBaseUrl(),
    headers: {
        'Client-Id': `${config?.id}`
    }
});

const winnreAuth = axios.create({
    baseURL: getBaseUrl(),
    headers: {
        'Client-Id': `${config?.clientId}`
    }
});

const winnreNoAuth = axios.create({
    baseURL: getBaseUrl(),
    headers: {
        'Client-Id': `${config?.clientId}`
    }
});

if (ENV === 'LOCAL') {
    const stripWinnrePrefix = (reqConfig) => {
        if (reqConfig.url) {
            reqConfig.url = reqConfig.url.replace(/^(\/)?winnre\/?/, '/');
        }
        return reqConfig;
    };
    winnreAuth.interceptors.request.use(stripWinnrePrefix);
    winnreNoAuth.interceptors.request.use(stripWinnrePrefix);
    cmsClient.interceptors.request.use(stripWinnrePrefix);
}

cmsClient.interceptors.response.use(
    function (response) {
        const newRes = { ...response };
        newRes.data = replaceCDNValues(response.data);
        return newRes;
    },
    function (err) {
        return err;
    }
);

winnreNoAuth.interceptors.response.use(
    async function (response) {
        let decrypt = await decryptData(response.data);
        return replaceCDNValues(JSON.parse(decrypt));
    },
    async function (error) {
        let decrypt = await decryptData(error.response.data);
        return JSON.parse(decrypt);
    }
);

winnreAuth.interceptors.response.use(
    async function (response) {
        try {
            const decrypt = await decryptData(response.data);
            return replaceCDNValues(JSON.parse(decrypt));
        } catch (err) {
            // Handle the error as needed
        }
    },
    async function (error) {
        const originalRequest = error.config;
        if (
            error.response &&
            error.response.status === 401 &&
            !originalRequest._retry
        ) {
            let decrypt = JSON.parse(await decryptData(error.response.data));
            // console.log(decrypt);
            if (decrypt.status == 'TOKEN_EXPIRED') {
                if (!isRefreshing) {
                    isRefreshing = true;
                    originalRequest._retry = true;

                    try {
                        const newAccessToken = await refreshToken();
                        isRefreshing = false;
                        processQueue(null, newAccessToken);
                        originalRequest.headers[
                            'Authorization'
                        ] = `Bearer ${newAccessToken}`;
                        return winnreNoAuth(originalRequest);
                    } catch (refreshError) {
                        isRefreshing = false;
                        processQueue(refreshError, null);
                        return Promise.reject(refreshError);
                    }
                } else {
                    return new Promise(function (resolve, reject) {
                        failedQueue.push({ resolve, reject });
                    })
                        .then((token) => {
                            originalRequest.headers[
                                'Authorization'
                            ] = `Bearer ${token}`;
                            return winnreNoAuth(originalRequest);
                        })
                        .catch((err) => {
                            return Promise.reject(err);
                        });
                }
            } else {
                toast.error(decrypt.message);
                return decrypt;
            }
        } else {
            if (error.response.status == 405) {
                toast.error(error.message);
            } else {
                let decrypt = await decryptData(error.response.data);
                return JSON.parse(decrypt);
            }
        }
    }
);

export { winnreAuth, winnreNoAuth, cmsClient };
